// extracted by mini-css-extract-plugin
export default {"item":"T7mB68"};